import _ from 'lodash'
import api, { listDehydrate, formCfg } from './api'

const dataSource = {
  getList(params, context) {
    return api
      .get('/api/polls/data_source/', formCfg(params, context))
      .then((response) => listDehydrate(response.data, dehydrate))
      .then((response) => _.sortBy(response, ['pk']))
  },
}

export function dehydrate({
  pk,
  name,
  isExternal,
  color,
  iconSmall,
  iconBig,
  iconBigDark,
  tooltip,
  externalUrlTitle,
}) {
  return {
    pk,
    name,
    isExternal,
    color,
    iconSmall,
    iconBig,
    iconBigDark,
    tooltip,
    externalUrlTitle,
  }
}

export function hydrate(dataSource, otherDataSourceName) {
  if (dataSource.pk === 0) {
    return { name: otherDataSourceName }
  } else {
    return dataSource
  }
}

export default dataSource
